<script setup>
import { useQuality } from '@/composables/useQuality'
import { useRouter } from 'vue-router'

definePage({
  meta: {
    layout: 'default',
    action: 'report',
    subject: 'Incident',
  },
})

const router = useRouter()
const { saving, reportIncident } = useQuality()

const form = ref({ incident_type_id: null, unit_id: null, title: '', chronology: '', occurred_at: '' })
const errors = ref({})

const save = async () => {
  errors.value = {}
  try {
    const incident = await reportIncident(form.value)

    router.push({ name: 'quality-incidents-id', params: { id: incident.id } })
  } catch (e) {
    if (e?.status === 422) errors.value = e?.data?.errors ?? {}
    else console.error('Report incident error:', e)
  }
}
</script>

<template>
  <div>
    <h4 class="text-h4 font-weight-bold mb-1">
      Lapor Insiden Keselamatan Pasien
    </h4>
    <p class="text-body-2 text-medium-emphasis mb-4">
      Nomor IKP dibuat otomatis setelah laporan disimpan (BR-009)
    </p>

    <VCard max-width="720">
      <VCardText class="pa-6">
        <VRow>
          <VCol
            cols="12"
            md="6"
          >
            <MasterDataPicker
              v-model="form.incident_type_id"
              entity="incident-types"
              label="Jenis Insiden *"
              :error-messages="errors.incident_type_id"
            />
          </VCol>
          <VCol
            cols="12"
            md="6"
          >
            <MasterDataPicker
              v-model="form.unit_id"
              entity="units"
              label="Unit"
              :error-messages="errors.unit_id"
            />
          </VCol>
          <VCol cols="12">
            <VTextField
              v-model="form.title"
              label="Judul Insiden *"
              :error-messages="errors.title"
            />
          </VCol>
          <VCol cols="12">
            <VTextField
              v-model="form.occurred_at"
              type="datetime-local"
              label="Tanggal/Waktu Kejadian *"
              :error-messages="errors.occurred_at"
            />
          </VCol>
          <VCol cols="12">
            <VTextarea
              v-model="form.chronology"
              label="Kronologi *"
              rows="4"
              :error-messages="errors.chronology"
            />
          </VCol>
        </VRow>
      </VCardText>
      <VCardActions class="pa-6 pt-0">
        <VSpacer />
        <VBtn
          variant="tonal"
          color="secondary"
          :disabled="saving"
          @click="router.push({ name: 'quality-incidents' })"
        >
          Batal
        </VBtn>
        <VBtn
          color="primary"
          :loading="saving"
          @click="save"
        >
          Simpan
        </VBtn>
      </VCardActions>
    </VCard>
  </div>
</template>
